/**
 * Handles focus leaving the activator: drops the open intent, or restores the activator text when
 * the menu is already closed. Focus that moves into the picker is ignored.
 *
 * @param {{ container: import("vue").Ref<HTMLElement | null>, menuOpen: import("vue").Ref<boolean>,
 *   menuShown: import("vue").Ref<boolean>, restoreActivatorText: () => void }} options
 *   `container` is the inner `sp-quantum-select`.
 * @returns {{ handleActivatorFocusOut: (event: FocusEvent) => void }}
 */
export function useSelectActivatorBlur({ container, menuOpen, menuShown, restoreActivatorText }) {
  // A press on a row retargets `relatedTarget` to the container, so it reads as focus staying inside.
  // A shown bottom sheet (the picker's `inSheetMode`) makes the activator inert, so its focus leaves
  // with no `relatedTarget`, and no other control can take focus until the sheet is dismissed, which
  // is the close on that path. A blocked picker shows no sheet, so there the leave drops the open
  // intent.
  function handleActivatorFocusOut(event) {
    if (container.value?.contains(event.relatedTarget)) {
      return;
    }

    if (menuOpen.value) {
      if (!(container.value?.inSheetMode && menuShown.value)) {
        menuOpen.value = false;
      }

      return;
    }

    restoreActivatorText();
  }

  return {
    handleActivatorFocusOut,
  };
}
